import axios from 'axios';

export default class BroadcastEvent {
    constructor() {
        if(document.getElementsByClassName('broadcast-event-section')[0]) {
            this.initPage();
        }
    }

    initPage() {
        this.formValidated = document.getElementById("formValidated")

        // Selection of other sales points
        const yesOtherSalePoints = document.getElementById("yesOtherSalePoints")
        const noOtherSalePoints = document.getElementById("noOtherSalePoints")
        const nameOtherSalePoints = document.getElementById("nameOtherSalePoints")
        yesOtherSalePoints.addEventListener("click", () => nameOtherSalePoints.style.display = "block")
        noOtherSalePoints.addEventListener("click", () => nameOtherSalePoints.style.display = "none")

        // Variables for input files
        this.inputsFile = document.querySelectorAll(".file-input")
        this.fileNames = ["roomPlan", "qrCode", "eventVisual", "organisationPresentation", "eventAuthorisation", "eventDocumentation"]
        this.selectedFiles = {}
        for (let name = 0; name < this.fileNames.length; name++){
            this.selectedFiles[this.fileNames[name]] = []
        }
        this.indexInputFile;
        this.nameInputFile;

        // Variables for the preview of input files
        const preview = document.getElementsByClassName("preview");
        for (let prev = 0; prev < preview.length; prev++) {
            preview[prev].style.display = "none"
        }

        // Detection if an input file is clicked
        this.detectFile()

        // Verification of the validation of the form
        this.validForm()
    }

    /**
     * Function for the detection if an input file is clicked
     */
     detectFile(){
        for (let files = 0; files < this.inputsFile.length; files++){
            this.inputsFile[files].addEventListener("change", () => {
                this.indexInputFile = files
                this.nameInputFile = this.fileNames[this.indexInputFile]
                const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];
                const fileExtension = [...this.inputsFile[files].files][0].name.split('.').pop().toLowerCase();
                // Update display of selected files if the size is ok
                if (this.validMaxSizeFile(this.inputsFile[files]) && allowedExtensions.includes('.' + fileExtension)){
                    this.updateDisplay()
                }
                else{
                    this.inputsFile[files].value = ""
                }
            });
        }
    }

    /**
     * Function for Update display of selected files
     */
    async updateDisplay() {
        // preview and div of the selected input file
        const preview = document.getElementsByClassName("preview")[this.indexInputFile];
        const uploadFileDiv = document.getElementsByClassName("main-upload")[this.indexInputFile]

        //files selected in the input
        let curFiles = [...this.inputsFile[this.indexInputFile].files];
        let tempSelectedFile = [...this.selectedFiles[this.nameInputFile]]

        // Verification if the selected file is a new file for the selected part
        let addedFile = await this.addFileToSelectedFile(curFiles, tempSelectedFile)

        if (addedFile){
            // If there is no file in the input file
            if (this.selectedFiles[this.nameInputFile].length === 0) {
                preview.style.display = "none"
                uploadFileDiv.style.marginBottom = "16px";
            }
            // If file in the input file
            else {
                await this.createInputComponent(preview, uploadFileDiv, addedFile)
                // Detection if an input file is clicked
                this.detectFile()
            }
        }


    }

    /**
     * Function for add file to selected file list and added file
     */
    addFileToSelectedFile(curFiles, tempSelectedFile){
        let addedFile;
        let curFile = curFiles[0]
        if (curFile === undefined){
            return addedFile;
        }
        else {
            if (this.indexInputFile !== 2) {
                if (tempSelectedFile.length === 0) {
                    this.selectedFiles[this.nameInputFile].push(curFile)
                    addedFile = curFile
                }
                else if ((tempSelectedFile.length !== 0) &&
                    (!(tempSelectedFile[0].name === curFile.name
                    && tempSelectedFile[0].size === curFile.size
                    && tempSelectedFile[0].lastModified === curFile.lastModified)))
                {
                    this.selectedFiles[this.nameInputFile] = []
                    this.selectedFiles[this.nameInputFile].push(curFile)
                    addedFile = curFile
                }
            }
            else {
                if (this.selectedFiles[this.nameInputFile].length === 0) {
                    this.selectedFiles[this.nameInputFile].push(curFile)
                    addedFile = curFile;
                }
                else {
                    let isDifferentFile = false
                    for (let file = 0; file < tempSelectedFile.length; file++) {
                        if (!tempSelectedFile.some(f => f.name === curFile.name
                                && f.size === curFile.size
                                && f.lastModified === curFile.lastModified))
                        {
                            isDifferentFile = true
                        }
                    }
                    if (isDifferentFile) {
                        this.selectedFiles[this.nameInputFile].push(curFile)
                        addedFile = curFile;
                    }
                }
            }
            return addedFile;
        }
    }

    /**
     * Function for create the new input component
     */
    async createInputComponent(preview, uploadFileDiv, addedFile){
        preview.style.display = "block"
        uploadFileDiv.style.marginBottom = "0px";

        // remove the file for the input with only one file
        if (this.indexInputFile !== 2) {
            while (preview.firstChild) {
                preview.removeChild(preview.firstChild);
            }
        }

        // Creation of the file component
        const uploadFile = document.createElement("div");
        uploadFile.className = "upload-file"
        uploadFile.id = addedFile.name + this.indexInputFile;
        uploadFile.style.border = "1px solid #E0E0E0"
        uploadFile.style.flexDirection = "column"

        const uploadFileLeft = document.createElement("div");
        uploadFileLeft.className = "upload-file-left"

        const img = document.createElement("img");
        img.src = "/images/file.svg"

        const uploadFileRight = document.createElement("div");
        uploadFileRight.className = "upload-file-right"
        uploadFileRight.style.display = "flex"
        uploadFileRight.style.gap = "20px"

        uploadFileLeft.appendChild(img)

        preview.appendChild(uploadFile);

        const paraLeft = document.createElement("p");
        paraLeft.className = "para-left"
        paraLeft.style.overflow = "hidden"
        paraLeft.style.whiteSpace = "nowrap"
        paraLeft.style.textOverflow = "ellipsis"
        paraLeft.style.maxWidth = "280px"

        const paraRight = document.createElement("p");

        const trash = document.createElement("img");
        trash.src = "/images/trash.svg"
        trash.style.cursor = "pointer"
        trash.style.display = "none"

        const progressBar = document.createElement("div")
        progressBar.className = "progress-bar"
        progressBar.style.display = "none"
        const bar = document.createElement("div")
        bar.className = "bar"

        const upload = document.createElement("div")
        upload.style.display = "flex"
        upload.style.width = "100%"
        upload.style.justifyContent = "space-between"
        upload.style.marginBottom = "0px"

        upload.appendChild(uploadFileLeft)
        upload.appendChild(uploadFileRight)

        progressBar.appendChild(bar)

        uploadFile.appendChild(upload)
        uploadFile.appendChild(progressBar)

        let fileSize = this.sizeOfFileInStringInBytes(addedFile)

        paraLeft.textContent = `${addedFile.name}`;
        paraRight.textContent = `${fileSize}`;

        uploadFileLeft.appendChild(paraLeft);
        uploadFileRight.appendChild(paraRight);
        uploadFileRight.appendChild(trash);

        // Loading animation
        await this.loading(progressBar)

        // Creation of the input (html) and move of the old
        uploadFile.appendChild(this.inputsFile[this.indexInputFile])
        this.inputsFile[this.indexInputFile].style.display = "none"
        const newInput = document.createElement("input")

        newInput.className = "file-input"
        newInput.type = "file"
        newInput.accept = ".jpeg, .png, .jpg, .pdf"

        this.inputsFile[this.indexInputFile].classList.add("upload")
        this.inputsFile[this.indexInputFile].classList.add(this.fileNames[this.indexInputFile])
        this.inputsFile[this.indexInputFile].classList.remove("file-input")
        this.inputsFile[this.indexInputFile].name = this.fileNames[this.indexInputFile]

        uploadFileDiv.appendChild(newInput)
        this.inputsFile = this.inputsFile = document.querySelectorAll(".file-input")

        // Remove the file
        trash.style.display = "inline"



        await this.removeFile(trash)
    }

    /**
     * Function for remove the file
     */
    async removeFile(trash) {
        const self = this
        trash.addEventListener( "click", async () => {
            const uploadFileContainer = trash.parentElement.parentElement.parentElement
            const inputFile = uploadFileContainer.getElementsByClassName("upload")[0]
            trash.style.display = "none"

            const progressBar = uploadFileContainer.getElementsByClassName("progress-bar")[0]
            if (self.indexInputFile === 2) {
                let files = self.selectedFiles["eventVisual"]
                self.selectedFiles["eventVisual"] = files.filter(files => files !== inputFile.files[0])
            } else {
                self.selectedFiles[inputFile.name] = []
            }

            await self.loading(progressBar)

            const mainInput = uploadFileContainer.parentElement.parentElement.getElementsByClassName("upload-file main-upload")[0].getElementsByClassName("file-input")

            if (self.selectedFiles[inputFile.name].length === 0) {
                if (inputFile.name !== "roomPlan" && inputFile.name !== "eventAuthorisation"){
                    mainInput.required = "true"
                }
            }

            inputFile.value = '';
            uploadFileContainer.remove()
        })

    }

    /**
     * Function for the animation of loading and remove the file
     */
    loading(progressBar) {
        progressBar.style.display = "inline";
        return new Promise(resolve => {
            const elem = document.getElementsByClassName("bar");
            let width = 1;
            let timeBeforeAnimation = 0
            const interval = setInterval(() => {
                if (width >= 100) {
                    progressBar.style.display = "none"
                    width = 0
                    timeBeforeAnimation = 0
                    clearInterval(interval);
                    resolve()
                } else {
                    if (timeBeforeAnimation >= 10) {
                        width = width * 1.02;
                    }
                    elem[0].style.width = width + "%";
                }
                timeBeforeAnimation++
            }, 1);
        });
    }

    /**
     * Function for the verification of the event types checkboxes
     */
     validCheckboxes(){
        const checkboxes = document.querySelectorAll('.eventDetails')
        const errorMessage = document.getElementById("errorMessage")
        for (let checkboxIndex = 0; checkboxIndex < checkboxes.length; checkboxIndex++){
            if (checkboxes[checkboxIndex].checked){
                errorMessage.classList.remove("errorMessageComponent")
                errorMessage.style.display = "none"
                return true
            }
        }
        errorMessage.classList.add("errorMessageComponent")
        errorMessage.style.display = "flex"
        errorMessage.style.marginTop = "20px";
        return false
    }

    /**
     * Function get the size of a file in a string with bytes, KB or MB
     */
    sizeOfFileInStringInBytes(addedFile){
        if (addedFile.size < 1e3) {
            return `${addedFile.size} bytes`;
        } else if (addedFile.size >= 1e3 && addedFile.size < 1e6) {
            return `${(addedFile.size / 1e3).toFixed(1)} KB`;
        } else {
            return `${(addedFile.size / 1e6).toFixed(1)} MB`;
        }
    }

    /**
     * Function for check if the size of a file is under 1 Mo
     */
     validMaxSizeFile(file){
        const curFile = [...file.files][0]
        const maxSizeMb = 1
        const maxSizeBytes = maxSizeMb * 1024 * 1024


        const errorSizeFileContainer = document.getElementById("errorSizeFileContainer" + (this.indexInputFile + 1))
        if (curFile && curFile.size > maxSizeBytes){
            errorSizeFileContainer.classList.add("errorMessageComponent")
            errorSizeFileContainer.style.display = "flex"
            errorSizeFileContainer.style.marginBottom = "0";
            return false
        }
        else {
            errorSizeFileContainer.classList.remove("errorMessageComponent")
            errorSizeFileContainer.style.display = "none"
            return true
        }
    }

    /**
     * Function for check if the total of all the file is under 8 Mo
     */
    validTotalSizeFiles(){
        const totalSizeTooHigh = document.getElementById("totalSizeTooHigh")
        const totalSizeTooHighText = document.getElementById("totalSizeTooHighText")
        const maxSizeMb = 8

        const maxSizeBytes = maxSizeMb * 1024 * 1024

        let filesTotalSize = 0
        for (let input = 0; input < this.fileNames.length; input++){
            for (let f = 0; f < this.selectedFiles[this.fileNames[input]].length; f++){
                filesTotalSize += this.selectedFiles[this.fileNames[input]][f].size
            }
        }

        if (filesTotalSize < maxSizeBytes){
            totalSizeTooHigh.classList.remove("errorMessageComponent")
            totalSizeTooHigh.style.display = "none"
            return true
        }
        else {
            if (filesTotalSize < 1e3) {
                filesTotalSize = `${filesTotalSize} bytes`;
            } else if (filesTotalSize >= 1e3 && filesTotalSize < 1e6) {
                filesTotalSize = `${(filesTotalSize / 1e3).toFixed(1)} KB`;
            } else {
                filesTotalSize = `${(filesTotalSize / 1e6).toFixed(1)} MB`;

            }
            totalSizeTooHigh.classList.add("errorMessageComponent")
            totalSizeTooHigh.style.display = "flex"
            totalSizeTooHigh.style.marginTop = "10px"
            totalSizeTooHighText.innerText = window.jsTranslations["size-file-first-part"] + " (" + filesTotalSize + " " + window.jsTranslations["size-file-second-part"] + "). " + window.jsTranslations["size-file-third-part"]
            return false
        }
    }

    /**
     * Function for validation of the form
     */
    validForm(){
        const self = this
        const form = document.getElementById("broadcastForm")
        form.addEventListener('submit', function (e){
            e.preventDefault()
            let eventVisualFile = document.getElementsByClassName("eventVisual")
            for (let fileIndex = 0; fileIndex < eventVisualFile.length; fileIndex++){
                eventVisualFile[fileIndex].name += fileIndex + 1
            }

            const formData = new FormData(form)

            let eventDetails = [];

            const clonedFormData = new FormData(form)
            clonedFormData.forEach((value, key) =>  {
                if (key.includes("eventDetails") && key !== "eventDetails") {
                    eventDetails.push(clonedFormData.get(key))
                    formData.delete(key)
                }
            });

            formData.set('eventDetails', eventDetails)

            if (self.validCheckboxes() && self.validTotalSizeFiles()){
                const submit = document.querySelector("input[type='submit']")
                const missingElement = document.getElementById("missingElement")
                const errorCaptcha = document.getElementById("errorCaptcha")
                submit.disabled = true

                grecaptcha.ready(() => {
                    grecaptcha.execute(window.portal_conf.RECAPTCHA_V3_SITE_KEY, {
                        action: 'submit'
                    }).then((token) => {
                        if (token) {
                            formData.set("recaptcha_response", token)
                            axios.post(`/api/send-broadcast-event`, formData)
                                .then(() => {
                                    self.formValidated.style.display = "inline"
                                    this.reset()
                                    const inputs = document.querySelectorAll(".upload")
                                    for (let input = 0; input < inputs.length; input++){
                                        inputs[input].value = ""
                                    }
                                    this.style.display = "none"
                                    missingElement.classList.remove("errorMessageComponent")
                                    missingElement.style.display = "none"
                                    errorCaptcha.classList.remove("errorMessageComponent")
                                    errorCaptcha.style.display = "none"
                                    submit.disabled = false
                                })
                                .catch((e) =>{
                                    if (e.response.status === 422){
                                        missingElement.classList.remove("errorMessageComponent")
                                        missingElement.style.display = "none"
                                        errorCaptcha.classList.add("errorMessageComponent")
                                        errorCaptcha.style.display = "flex"
                                    }
                                    else{
                                        errorCaptcha.classList.remove("errorMessageComponent")
                                        errorCaptcha.style.display = "none"
                                        missingElement.classList.add("errorMessageComponent")
                                        missingElement.style.display = "flex"
                                    }
                                    submit.disabled = false
                                })
                        }
                    });
                });
            }
        })
    }
}


